import {
    BreadCrumbItem,
    BreadCrumbs as BreadCrumbsComponent,
} from '@eventbrite/breadcrumbs-infra';
import { gettext } from '@eventbrite/i18n';
import React from 'react';

interface CollectionPageBreadCrumbProps {
    collectionName: string;
    collectionId: string;
}

export const CollectionPageBreadCrumb: React.FunctionComponent<
    CollectionPageBreadCrumbProps
> = (props) => {
    const collectionName = props.collectionName;
    const collectionId = props.collectionId;
    const breadcrumbItems = React.useMemo<BreadCrumbItem<{}>[]>(() => {
        return [
            { value: '/', display: gettext('Home') },
            { value: collectionId, display: collectionName },
        ];
    }, [collectionName, collectionId]);

    return (
        <BreadCrumbsComponent
            items={breadcrumbItems}
            separator={
                <span style={{ paddingLeft: '8px', paddingRight: '8px' }}>
                    /
                </span>
            }
            shouldIncludeMicroData={true}
        >
            {(item: any) => (
                <a {...item.valueMicrodataProps} href={item.value}>
                    {item.displayWithMicroData}
                </a>
            )}
        </BreadCrumbsComponent>
    );
};
